import React from 'react';
import PropTypes from 'prop-types';


function FeeMessage(props) {
  const { shouldRenderFeeMessage } = props;
  const feeMessage = 'A $1.00 transaction fee will be added to your purchase';

  if (!shouldRenderFeeMessage) {
    return null;
  }

  return (
    <p className="small-font text-secondary fee-message">
      {feeMessage}
    </p>
  );
}

export default FeeMessage;

FeeMessage.defaultProps = { shouldRenderFeeMessage: false };

FeeMessage.propTypes = { shouldRenderFeeMessage: PropTypes.string };
